import { Injectable } from '@angular/core';
import { AppAPIConfig } from './app-api-config';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSetupService {
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForDelete: any;
  httpOptionsForExportToExcel: {};

  //userId = localStorage.getItem('userid');

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };


  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };
  }
  // Partner
  getPartners() {
    return this.http.get(this.appApi.userPartnerAPI, this.httpOptions);
  }

  getSectors() {
    return this.http.get(this.appApi.sectorAPI, this.httpOptions);
  }

  getEdiaryStatus() {
    return this.http.get(this.appApi.ediaryStatusAPI, this.httpOptions);
  }

  getLegalStatus() {
    return this.http.get(this.appApi.legalStatusAPI, this.httpOptions);
  }

  getCheckList() {
    return this.http.get(this.appApi.checklistAPI, this.httpOptions);
  }

  // Clients
  getClients() {
    return this.http.get(this.appApi.clientAPI, this.httpOptions);
  }

  deleteClient(id) {
    return this.http.delete<any>(
      this.appApi.clientAPI + '/' + id,
      this.httpOptions
    );
  }

  saveClient(body) {
    return this.http.post<any>(this.appApi.clientAPI, body, this.httpOptions);
  }

  viewClient(id) {
    return this.http.get(this.appApi.clientAPI + '/' + id, this.httpOptions);
  }

  // Conveyance Rates
  getConveyance(branchId) {
    return this.http.get(
      this.appApi.conveyanceAPI + '/branch/' + branchId,
      this.httpOptions
    );
  }

  deleteConveyance(id) {
    return this.http.delete<any>(
      this.appApi.conveyanceAPI + '/' + id,
      this.httpOptions
    );
  }

  saveConveyance(body) {
    return this.http.post<any>(
      this.appApi.conveyanceAPI,
      body,
      this.httpOptions
    );
  }

  viewConveyance(id) {
    return this.http.get(
      this.appApi.conveyanceAPI + '/' + id,
      this.httpOptions
    );
  }

  updateConveyance(body) {
    return this.http.put<any>(
      this.appApi.conveyanceAPI,
      body,
      this.httpOptions
    );
  }

  // Conveyance Rates
  getStandardRates(selectYearId, selectBranchId) {
    return this.http.get(this.appApi.standardrateAPI + '/' + selectYearId + '/' + selectBranchId,
      this.httpOptions);
  }

  deleteStandardRate(id) {
    return this.http.delete<any>(
      this.appApi.standardrateAPI + '/' + id,
      this.httpOptions
    );
  }

  saveStandardRate(body) {
    return this.http.post<any>(
      this.appApi.standardrateAPI,
      body,
      this.httpOptions
    );
  }

  viewStandardRate(id) {
    return this.http.get(
      this.appApi.standardrateAPI + '/' + id,
      this.httpOptions
    );
  }

  updateStandardRate(body) {
    return this.http.put<any>(
      this.appApi.standardrateAPI,
      body,
      this.httpOptions
    );
  }

  // Branch Holidays
  getBranchHolidays(id, fyId) {
    return this.http.get(
      this.appApi.branchHolidayAPI + '/' + id + '/' + fyId,
      this.httpOptions
    );
  }

  deleteBranchHoliday(item) {
    return this.http.delete<any>(
      this.appApi.createUpdateBranchHolidayAPI + '/' + item.branch.id + '/' + item.id,
      this.httpOptions
    );
  }

  saveBranchHoliday(body) {
    return this.http.post<any>(
      this.appApi.createUpdateBranchHolidayAPI,
      body,
      this.httpOptions
    );
  }

  viewBranchHoliday(id) {
    return this.http.get(
      this.appApi.branchHolidayAPI + '/' + id,
      this.httpOptions
    );
  }

  updateBranchHoliday(body) {
    return this.http.put<any>(
      this.appApi.createUpdateBranchHolidayAPI,
      body,
      this.httpOptions
    );
  }

  // Article Stipend
  getArticleStipend(fyId, banchId) {
    return this.http.get(
      this.appApi.getArticleStipendAPI + '/' + fyId + '/' + banchId,
      this.httpOptions
    );
  }

  deleteArticleStipend(id) {
    return this.http.delete<any>(
      this.appApi.articleStipendAPI + '/' + id,
      this.httpOptions
    );
  }

  saveArticleStipend(body) {
    return this.http.post<any>(
      this.appApi.articleStipendAPI,
      body,
      this.httpOptions
    );
  }

  viewArticleStipend(id) {
    return this.http.get(
      this.appApi.articleStipendAPI + '/' + id,
      this.httpOptions
    );
  }

  updateArticleStipend(body) {
    return this.http.put<any>(
      this.appApi.articleStipendAPI,
      body,
      this.httpOptions
    );
  }

  // Article Stipend
  getCompanyConfig() {
    return this.http.get(this.appApi.companysetupAPI, this.httpOptions);
  }

  saveCompanyConfig(body) {
    return this.http.post<any>(
      this.appApi.companysetupAPI,
      body,
      this.httpOptions
    );
  }

  updateCompanyConfig(body) {
    return this.http.put<any>(
      this.appApi.companysetupAPI,
      body,
      this.httpOptions
    );
  }

  //
  getPartnerListForBranch(branchId) {
    return this.http.get(
      this.appApi.profileAPI + '/partner/' + branchId,
      this.httpOptions
    );
  }

  getClientListForPartner(partnerId) {
    return this.http.get(
      this.appApi.clientAPI + '/partner/' + partnerId,
      this.httpOptions
    );
  }

  getStandardRate(yearId, branchId, roleId) {
    var str = yearId + '/' + branchId + '/' + roleId;
    return this.http.get(
      this.appApi.standardrateAPI + '/role/' + str,
      this.httpOptions
    );
  }

  getStandardRateByServiceVertical(yearId, branchId, serviceVertical, roleId) {
    var str = yearId + '/' + branchId + '/' + serviceVertical + '/' + roleId;
    return this.http.get(
      this.appApi.standardrateAPI + '/role/' + str,
      this.httpOptions
    );
  }

  getEmployeesForRoles(roleId) {
    return this.http.get(
      this.appApi.profileAPI + '/role/' + roleId,
      this.httpOptions
    );
  }

  //  getEmployeesForServiceVerticalAndRoles(branchId, verticalId, roleId) {
  //   return this.http.get(
  //     this.appApi.usersByserviceVerticalAndRoleAPI +
  //     "?branch=" +branchId +"&serviceVertical=" +verticalId +"&roles='"+roleId+"'",
  //     this.httpOptions
  //   );
  // }

  getEmployeesForServiceVerticalAndRoles(verticalId, roleId) {
    return this.http.get(
      this.appApi.userByRoleServiceVerticalAPI +
      "?serviceVertical=" +verticalId +"&roles='"+roleId+"'",
      this.httpOptions
    );
  }

  getExistingBudget(yearId, branchId, partnerId, clientId, assignmentId) {
    var str =
      yearId +
      '/' +
      branchId +
      '/' +
      partnerId +
      '/' +
      clientId +
      '/' +
      assignmentId;
    return this.http.get(
      this.appApi.budgetAPI + '/detail/' + str,
      this.httpOptions
    );
  }

  saveBudget(body) {
    return this.http.post<any>(this.appApi.budgetAPI, body, this.httpOptions);
  }

  updateBudget(body, budgetId) {
    return this.http.put<any>(
      this.appApi.budgetAPI + '/' + budgetId,
      body,
      this.httpOptions
    );
  }

  createAnnouncement(data) {
    return this.http.post<any>(this.appApi.createAnnouncementAPI, data, this.httpOptions);
  }

  createImageForAnnouncemnt(data, imageUploadValue, userId) {
    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.put<any>(this.appApi.creatAnnouncementImageAPI + '/' + userId + '/' + imageUploadValue, data, uploadHttpOptions);
  }

  getAnnouncement() {
    return this.http.get(
      this.appApi.getAnnouncementAPI,
      this.httpOptions
    );
  }

  updateAnnouncement(body) {
    console.log('body', body);
    return this.http.put<any>(
      this.appApi.updateAnnouncementAPI,
      body,
      this.httpOptions
    );
  }
  updateImageForAnnouncemnt(data, announceId) {
    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.put<any>(this.appApi.updateAnnouncementImageAPI + '/' + announceId + '?file', data, uploadHttpOptions);
  }

  deleteAnnouncement(id) {
    return this.http.delete<any>(
      this.appApi.deleteAnnouncementAPI + '/' + id,
      this.httpOptions
    );
  }

  getAnnouncementHistory(fromDate, toDate) {
    return this.http.get(
      this.appApi.getAnnouncementHistoryAPI + '/' + fromDate + '/' + toDate,
      this.httpOptions
    )
  }

  getPartnerListDetails() {
    return this.http.get(this.appApi.partnerListAPI, this.httpOptions)
  }

  saveArticleVacancyDetails(body) {
    return this.http.post<any>(this.appApi.articleVacancyAPI, body, this.httpOptions);
  }

  getArticleVacancyDetails() {
    return this.http.get(this.appApi.articleVacancyAPI, this.httpOptions)
  }

  updateArticleVacancyDetails(body) {
    return this.http.put<any>(this.appApi.articleVacancyAPI, body, this.httpOptions);
  }

  deleteArticleVacancyDetails(id) {
    return this.http.delete<any>(this.appApi.articleVacancyAPI + '/' + id, this.httpOptions);
  }

  getMisDetails(financialYear, Quarter) {
    return this.http.get(
      this.appApi.getMisDetailsAPI + '/' + financialYear + '/' + Quarter,
      this.httpOptions
    )
  }

  getAssignmentbyPartner(fyId, clientId, partnerId) {
    return this.http.get(
      this.appApi.assignmentByPartner + '/' + fyId + '/' + clientId + '&' + partnerId,
      this.httpOptions
    )
  }

  getAssignmentFeesForClient(fyId, clientId, assignmentId) {
    return this.http.get(
      this.appApi.assignmentFeesForClient + '/' + fyId + '/' + clientId + '/' + assignmentId,
      this.httpOptions
    )
  }

  getAssignmentFeesForClientForFy(fyId, clientId) {
    return this.http.get(
      this.appApi.assignmentFeesForClientForFy + '/' + fyId + '/' + clientId,
      this.httpOptions
    )
  }

  saveMisDetails(body) {
    return this.http.post<any>(this.appApi.saveMisDetails, body, this.httpOptions);
  }

  submitMisDetails(data, misId) {

    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.put<any>(this.appApi.submitMisDetails + '/' + misId, data, uploadHttpOptions);
  }

  getMisReportDetailsAPI(partnerId, financialYearId, quarterId) {

    const url =
      this.appApi.misReportDetails +
      '/' +
      financialYearId +
      '?userId=' +
      partnerId +
      "&quarter='" +
      quarterId +
      "'";

    return this.http.get(url, {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token') ?? '',
        'Content-Type': 'application/json',
      }),
      responseType: 'blob' as 'blob'
    });



  }



  uploadMisDocuments(data, misId) {
    var uploadHttpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    }
    return this.http.put<any>(this.appApi.uploadMisDocuments + '/' + misId, data, uploadHttpOptions);
  }

  updateMisDetails(body) {
    return this.http.put<any>(this.appApi.saveMisDetails, body, this.httpOptions);
  }

  getCtcDetails(id, fyId) {
    return this.http.get(
      this.appApi.ctcDetailsReportAPI + '/' + fyId + '/' + id,
      this.httpOptions
    );
  }
}
